module.exports = __webpack_public_path__ + "img/c06_unittechcodeofhammurabi_Normal_ua.654c6a58.webp";